import './App.css';
import Login from './components/login';
import FormularioCheckInExpress from './components/formularioCheckInExpress';
import FormularioBusquedaReserva from './components/validarCheckInExpress';
import FormularioEditarPerfil from './components/Profile';
import UsuariosSistema from './components/users';
import Logout from './components/Logout';
import React from 'react';
import { Routes, Route, HashRouter } from 'react-router-dom';
import PrivateRoute from './utils/PrivateRoute';
import Auditoria from './components/auditoria';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/users"
          element={
            <PrivateRoute allowedRoles={['Recepcionista_EBRO', 'Recepcionista_RADISSON', 'Administrador_USUARIOS']} />
          }
        >
          <Route index element={<UsuariosSistema />} />
        </Route>

        <Route
          path="/auditoria"
          element={
            <PrivateRoute allowedRoles={['Administrador_USUARIOS']} />
          }
        >
          <Route index element={<Auditoria />} />
        </Route>

        {/* ✅ Pública: accesible desde internet */}
        <Route
          path="/formCheckInExpress/:businessUnit/:confirmationId"
          element={<FormularioCheckInExpress />}
        />

        <Route
          path="/validarCheckInExpress"
          element={
            <PrivateRoute allowedRoles={['Recepcionista_EBRO', 'Recepcionista_RADISSON', 'Administrador_USUARIOS']} />
          }
        >
          <Route index element={<FormularioBusquedaReserva />} />
        </Route>

        <Route
          path="/Logout"
          element={
            <PrivateRoute allowedRoles={['Recepcionista_EBRO', 'Recepcionista_RADISSON', 'Administrador_USUARIOS']} />
          }
        >
          <Route index element={<Logout />} />
        </Route>

        <Route
          path="/profile"
          element={
            <PrivateRoute allowedRoles={['Recepcionista_EBRO', 'Recepcionista_RADISSON', 'Administrador_USUARIOS']} />
          }
        >
          <Route index element={<FormularioEditarPerfil />} />
        </Route>

      </Routes>
    </HashRouter>
  );
}

export default App;
